module.exports = __webpack_public_path__ + "static/img/seal.b345ed0c.png";